import bigInt from 'big-integer'

import { httpError } from '../js/http.js'
import { apiGet, handleResponse } from './default'

const base = process.env.SSO_BASE_URL || '';

let m_K16 = new Array();

const getXML = (path,options) => fetch(path, options)
    .then(res => res.text())
    .then(str => (new window.DOMParser()).parseFromString(str, 'text/xml'));

function generateK(A, b, p) {
    var hashin = A.modPow(b, p);
    var m_K = parseBigInt(calcSHA1Hex(hashin), 16);
    var kb = m_K.toByteArray();
    for (var k = 0; k < 16; k = k + 1) {
        m_K16[k] = kb[k];
    }
}

function calculate_K(A, b, p) {
    let hv = A.modPow(b, p).toString(16);
    var hashin = String(bigInt2radix(verifyHexVal(hv), 16));
    var m_K = parseBigInt(calcSHA1Hex(hashin), 16);
    var kb = m_K.toByteArray();
    for (var k = 0; k < 16; k = k + 1) {
        m_K16[k] = kb[k];
    }
    return m_K;
}

function getRandomB(m_g, m_p, random) {
    const m_N = new bigInt("d4c7f8a2b32c11b8fba9581ec4ba4f1b04215642ef7355e37c0fc0443ef756ea2c6b8eeb755a1c723027663caa265ef785b8ff6a9b35227a52d86633dbdfca43", 16);
    const one = new bigInt("1", 16);
    const two = new bigInt("2", 16);
    let m_b = new bigInt(8 * 32, random); // change for secure random
    if (m_b.compareTo(m_N) >= 0) {
        m_b = m_b.mod(m_N.subtract(one));
    }
    if (m_b.compareTo(two) < 0) {
        m_b = two;
    }
    return m_g.modPow(m_b, m_p);
}

function genS() {
    return Math.floor((1+ Math.random()) * 0x10000 ).toString(16).substring(1);
}

export function authSsodh() {
    return apiGet('/ssodh/init');
}

export function logout() {
    return getXML(base + '/Logout', { credentials: 'include' });
}

export function generateQrCode() {
    return fetch(base + '/qr-codes?ACTION=GENERATE', { credentials: 'include' })
        .then(handleResponse);
}

export function startSSODH(deviceId, MAC) {
    let url = '';
    let K = '';
    return getXML(base + '/AuthenticateSSODH?ACTION=INIT', { redirect: 'error' })
        .then(res => {
            const p = new bigInt(res.getElementsByTagName('p')[0].textContent, 16);
            const g = new bigInt(res.getElementsByTagName('g')[0].textContent, 16);
            const A = new bigInt(res.getElementsByTagName('A')[0].textContent, 16);
            const challenge = new bigInt(res.getElementsByTagName('challenge')[0].textContent, 16);
            if (!p || !g || !A || !challenge) {
                throw new Error('AuthenticateSSODH: missing params');
            }
            const b = new bigInt(randomBigInt(32).toString(16), 16);
            const B = g.modPow(b, p);
            K = calculate_K(A, b, p);
            const chalResponse = new bigInt(calcSHA1Hex(challenge.toString(16) + K.toString(16)), 16);
            url = base + '/AuthenticateSSODH?ACTION=COMPLETE&B=' + B.toString(16) + 
                '&CHRESPONSE=' + chalResponse.toString(16) + 
                '&DEVICEID=' + (deviceId && deviceId.toUpperCase()) + '|' + MAC
            return getXML(url, { credentials: 'include' });
        })
        .then(res => {
            const encTag = res.getElementsByTagName('enc');
            if (encTag[0] === undefined) {
                throw ({error: 'SSODH handshake failed', result: res});
            }
            const enc = encTag[0].textContent;
            const einfo = parseBigInt(res.getElementsByTagName('einfo')[0].textContent, 16);
            const username = decrypt(einfo.toByteArray(), m_K16);
            return ({ username: username, K: K });
        });
}

export function authenticateSSODH(deviceId, MAC) {
    return startSSODH(deviceId, MAC)
        .catch(res => {
            throw 'startSSODH failed: ' + httpError(res);
        });
}
